import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useHistory } from "react-router-dom";

import CloseIcon from "../../../assets/icons/close.svg";
import { ReactComponent as ArrowNextWhite } from "./../../../assets/icons/arrowNextWhite.svg";
import { ReactComponent as CheckRegister } from "./../../../assets/icons/checkRegister.svg";
import { ReactComponent as Warning } from "./../../../assets/icons/warning-red.svg";

import { App, Auth } from "../../../routes/Constants";
import QuitModal from "../../common/Modal/QuitModal";
import APIVariables from "../../../services/api-variables";

import { registrationCategory } from "../../../constants/register.constants";

import axios from "axios";
import Footer from "../../common/Footer/Footer";

import Loader from "../../common/Loader/Loader";
import LocalStorage from "../../../shared/localStorage";
import ReRegisterFormPharmacy from "./ReRegisterFormPharmacy";
import StyledRegister from "../../authentication/StyledRegister";
import { errorMessages } from "../../../constants/errorMessages.constants";
import {
  handleCatch,
  verifyUserType,
  verifyUserTypeConnectedRegistrar,
} from "../../../shared/helpers";
import ReRegisterFormPrescriberNurseRegistrar from "./ReRegisterFormPrescriberNurseRegistrar";

if (process.env.NODE_ENV !== "test") Modal.setAppElement("#root");

const ReRegister = () => {
  const isPrescriber = verifyUserType(registrationCategory.PRESCRIBER);
  const isPharmacy = verifyUserType(registrationCategory.PHARMACY);
  const isConnectedNurse = verifyUserTypeConnectedRegistrar(
    registrationCategory.CONNECTED_NURSE
  );
  const isConnectedRegistrar = verifyUserTypeConnectedRegistrar(
    registrationCategory.CONNECTED_REGISTRAR
  );

  const history = useHistory();

  const [, setErrorMessage] = useState("");

  const [stateRegister, setStateRegister] = useState(1);
  const [registerForm, setRegisterForm] = useState({});

  //   const [isSubmitting, setIsSubmitting] = useState(false);

  const [quitModalIsOpenError, setIsOpenQuitError] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  let customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "37%",
    },
  };

  const mediaMatch = window.matchMedia("(max-width: 850px)");
  mediaMatch.matches === true
    ? (customStyles.content = {
        ...customStyles.content,
        width: "70%",
      })
    : (customStyles.content = {
        ...customStyles.content,
        width: "37%",
      });

  const [modalMessage, setErrorModalMessage] = useState({
    title: "",
    description: "",
  });

  const [quitModalIsOpen, setIsOpenQuit] = useState(false);
  const [isExpiredModalDisplayed, setIsExpiredModalDisplayed] = useState(false);
  const [isReRegisterComplete, setIsReregisterComplete] = useState(false);

  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  const isAccountExpired = !!localStorage.getItem(LocalStorage.EXPIRED_IRELAND);

  useEffect(() => {
    getPAFDetails();
    const isStatusExpiredTrue =
      localStorage.getItem(LocalStorage.EXPIRED_IRELAND) === "true";

    isStatusExpiredTrue && setIsExpiredModalDisplayed(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPAFDetails = async () => {
    const res = await axios
      .get(process.env.REACT_APP_BASE_URL + APIVariables.USERS_PROFILE, {
        headers: {
          Authorization: parseLocalStorage.token,
        },
      })
      .catch((error) => {
        handleCatch(error);
      });

    if (res.status === 200) {
      let userInfo = res.data;
      userInfo.type = registrationCategory.RE_REGISTER;
      setRegisterForm(userInfo);

      setIsLoading(false);
    }
  };

  function closeRegisterForm() {
    setIsOpenQuit(true);
  }

  function closeModalQuit() {
    setIsOpenQuit(false);
  }

  function closeModalQuitError() {
    setIsOpenQuitError(false);
    setErrorModalMessage({
      title: "",
      description: "",
    });
  }

  function closeIsExpiredModalDisplayed() {
    setIsExpiredModalDisplayed(false);
    localStorage.setItem(LocalStorage.EXPIRED_IRELAND, false);
  }

  function logIn() {
    history.push(Auth.LOGIN);
  }

  function redirectToDashboard() {
    window.location.href = App.DASHBOARD;
  }

  const submitFormPrescriber = async () => {
    return new Promise(async (response, rej) => {
      setErrorMessage("");

      const res = await axios
        .put(
          process.env.REACT_APP_BASE_URL + APIVariables.USERS_REREGISTRATION,
          {},
          {
            headers: {
              Authorization: parseLocalStorage.token,
            },
          }
        )
        .catch(function (error) {
          handleCatch(error);

          const errors = error.response.data;
          const errorsArray = [];
          if (typeof errors === "string") {
            errorsArray.push(errorMessages.INTERNAL_SERVER_ERROR);
          } else {
            Object.keys(errors).forEach((key) => {
              errorsArray.push(key + " - " + errors[key]);
            });
          }

          setErrorMessage(errorsArray);
          return response(errorsArray);
        });

      if (res?.status === 200) {
        localStorage.removeItem(LocalStorage.EXPIRED_IRELAND);
        localStorage.removeItem(LocalStorage.ABOUT_TO_EXPIRE_IRELAND);
        localStorage.removeItem(
          LocalStorage.HAS_ACCESS_TO_THE_RE_REGISTER_IRELAND
        );
        setIsReregisterComplete(true);
      }
    });
  };

  async function nextPage() {
    if (isPrescriber || isConnectedNurse || isConnectedRegistrar) {
      await submitFormPrescriber();
    } else {
      if (stateRegister === 1) {
        if (isPharmacy) {
          setStateRegister(stateRegister + 1);
        }
      }

      if (stateRegister === 2) {
        if (!areAllFieldsValidScreen3) {
          setErrorModalMessage({
            title: errorMessages.PHARMACY_NOT_AGREED_REQUIRMENTS,
            description:
              errorMessages.PHARMACY_NOT_AGREED_REQUIRMENTS_DESCRIPTION,
          });

          setIsOpenQuitError(true);
        } else {
          await submitForm();
        }
      }
    }
  }

  const submitForm = async () => {
    return new Promise(async (response, rej) => {
      setErrorMessage("");

      const confirmationOptions = {
        confirmation_terms: registerForm.confirmation_terms,
        confirmation_reqs_compliance: registerForm.confirmation_reqs_compliance,
        confirmation_auth: registerForm.confirmation_auth,
        confirmation_supervised: registerForm.confirmation_supervised,
        confirmation_aged_verification:
          registerForm.confirmation_aged_verification,
        confirmation_other: registerForm.confirmation_other,
        confirmation_other1: registerForm.confirmation_other1,
        confirmation_other2: registerForm.confirmation_other2,
        confirmation_other3: registerForm.confirmation_other3,
      };

      const res = await axios
        .put(
          process.env.REACT_APP_BASE_URL + APIVariables.USERS_REREGISTRATION,
          confirmationOptions,
          {
            headers: {
              Authorization: parseLocalStorage.token,
            },
          }
        )
        .catch(function (error) {
          handleCatch(error);

          const errors = error.response.data;
          const errorsArray = [];
          if (typeof errors === "string") {
            errorsArray.push(errorMessages.INTERNAL_SERVER_ERROR);
          } else {
            Object.keys(errors).forEach((key) => {
              errorsArray.push(key + " - " + errors[key]);
            });
          }

          setErrorMessage(errorsArray);
          return response(errorsArray);
        });

      if (res?.status === 200) {
        localStorage.removeItem(LocalStorage.EXPIRED_IRELAND);
        localStorage.removeItem(LocalStorage.ABOUT_TO_EXPIRE_IRELAND);
        localStorage.removeItem(
          LocalStorage.HAS_ACCESS_TO_THE_RE_REGISTER_IRELAND
        );
        setIsReregisterComplete(true);
      }
    });
  };

  const previous = () => {
    if (stateRegister === 1) {
      return;
    }
    setStateRegister(stateRegister - 1);
  };

  const handleChangeCheckBox = (e) => {
    const { name, checked } = e.target;

    setRegisterForm((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const disablePrevButton = () => {
    return stateRegister === 1;
  };

  const validateScreen3 = ({
    confirmation_terms = false,
    confirmation_reqs_compliance = false,
    confirmation_auth = false,
    confirmation_supervised = false,
    confirmation_aged_verification = false,
    confirmation_other = false,
    confirmation_other1 = false,
    confirmation_other2 = false,
    confirmation_other3 = false,
  }) => ({
    confirmation_terms: {
      isValid: confirmation_terms,
    },
    confirmation_reqs_compliance: {
      isValid: confirmation_reqs_compliance,
    },
    confirmation_auth: {
      isValid: confirmation_auth,
    },
    confirmation_supervised: {
      isValid: confirmation_supervised,
    },
    confirmation_aged_verification: {
      isValid: confirmation_aged_verification,
    },
    confirmation_other: {
      isValid: confirmation_other,
    },
    confirmation_other1: {
      isValid: confirmation_other1,
    },
    confirmation_other2: {
      isValid: confirmation_other2,
    },
    confirmation_other3: {
      isValid: confirmation_other3,
    },
  });

  let areAllFieldsValidScreen3;

  const {
    confirmation_terms,
    confirmation_reqs_compliance,
    confirmation_auth,
    confirmation_supervised,
    confirmation_aged_verification,
    confirmation_other,
    confirmation_other1,
    confirmation_other2,
    confirmation_other3,
  } = registerForm;

  const validateScreen3Fields = validateScreen3({
    confirmation_terms,
    confirmation_reqs_compliance,
    confirmation_auth,
    confirmation_supervised,
    confirmation_aged_verification,
    confirmation_other,
    confirmation_other1,
    confirmation_other2,
    confirmation_other3,
  });

  areAllFieldsValidScreen3 = Object.values(validateScreen3Fields).every(
    (field) => {
      return field.isValid;
    }
  );

  if (isLoading) return <Loader />;
  return (
    <React.Fragment>
      <StyledRegister>
        <div className="layout-modal">
          {isAccountExpired === false && (
            <div className="close-icon" onClick={closeRegisterForm}>
              <img src={CloseIcon} alt="Close Icon" />
            </div>
          )}

          {isPharmacy ? (
            <div className="step font-size-18">Step {stateRegister}/3</div>
          ) : (
            <div className="step font-size-18">Step {stateRegister}/1</div>
          )}

          {isPharmacy ? (
            <ReRegisterFormPharmacy
              stateRegister={stateRegister}
              registerForm={registerForm}
              nextPage={nextPage}
              handleChangeCheckBox={handleChangeCheckBox}
            />
          ) : (
            <ReRegisterFormPrescriberNurseRegistrar
              registerForm={registerForm}
              isPrescriber={isPrescriber}
              isConnectedNurse={isConnectedNurse}
            />
          )}

          <div className="wrapper-buttons-select-type">
            <button
              onClick={previous}
              className="prev"
              disabled={disablePrevButton()}
            >
              Previous
            </button>
            <div className="flex-justify">
              <div className="symbol-idication mr-4">
                *symbol indicating a mandatory field
              </div>
              <button className="primary-button" onClick={nextPage}>
                {isPrescriber || isConnectedNurse || isConnectedRegistrar
                  ? "Re-Register"
                  : stateRegister === 2 && isPharmacy
                  ? "Re-Register"
                  : "Next"}{" "}
                <ArrowNextWhite />
              </button>
            </div>
          </div>
        </div>

        {quitModalIsOpen && (
          <QuitModal
            quitModalIsOpen={quitModalIsOpen}
            closeModalQuit={closeModalQuit}
            quitModal={logIn}
            description="Are you sure you want to cancel filling out this registration form? All progress will be lost and you will need to start again."
          />
        )}

        <Modal
          isOpen={quitModalIsOpenError}
          onRequestClose={closeModalQuitError}
          style={customStyles}
          contentLabel="Error Modal"
          overlayClassName="overlay-modal"
          shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
        >
          <button onClick={closeModalQuitError} className="close-icon-button ">
            <img src={CloseIcon} alt="Close Icon" />
          </button>
          <div className="wrapper-modal">
            <div className="image">
              <Warning />
            </div>
            <div className="main-text-error">{modalMessage.title}</div>
            <div className="second-text">{modalMessage.description}</div>
          </div>
          <div className="wrapper-buttons">
            <button className="cancel mr-6" onClick={closeModalQuitError}>
              Cancel
            </button>
            <button className="red-button" onClick={closeModalQuitError}>
              Continue <ArrowNextWhite />
            </button>
          </div>
        </Modal>

        <Modal
          isOpen={isExpiredModalDisplayed}
          style={customStyles}
          contentLabel="Error Modal"
          overlayClassName="overlay-modal"
          shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
        >
          <div className="wrapper-modal">
            <div className="image">
              <Warning />
            </div>
            <div className="main-text-error">Registration Expired</div>
            <div className="second-text">
              Your account validity has expired. To re-instate your access,
              please click here to follow the re-regsitration process, and
              complete your training
            </div>
          </div>
          <div className="wrapper-buttons">
            <button
              className="red-button"
              onClick={closeIsExpiredModalDisplayed}
            >
              Re-Register <ArrowNextWhite />
            </button>
          </div>
        </Modal>

        <Modal
          isOpen={isReRegisterComplete}
          style={customStyles}
          contentLabel="Success Modal"
          overlayClassName="overlay-modal"
          shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
        >
          <button onClick={redirectToDashboard} className="close-icon-button ">
            <img src={CloseIcon} alt="Close Icon" />
          </button>
          <div className="wrapper-modal">
            <div className="image">
              <CheckRegister />
            </div>
            <div className="main-text">Re-Registration Complete</div>
            <div className="second-text">
              Thank you for renewing your account on the Patient Safety Hub.
              Click the link below to continue.
            </div>
          </div>
          <div className="wrapper-buttons">
            <button className="green-button" onClick={redirectToDashboard}>
              Continue <ArrowNextWhite />
            </button>
          </div>
        </Modal>
      </StyledRegister>
      <Footer />
    </React.Fragment>
  );
};
export default ReRegister;
